import LiveBox from '../live/LiveBox';
import {lives} from '../live/liveData';
import {Pagination, A11y, Navigation, Autoplay} from 'swiper';

import {Swiper, SwiperSlide} from 'swiper/react';

import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import 'swiper/css/a11y';


export default function LiveList() {
	return (
		<Swiper
			className="my-0 mx-4"
			modules={[Pagination, Autoplay, Navigation, A11y]}
			spaceBetween={50}
			slidesPerView={1}
			autoplay={{
				delay: 5000,
				disableOnInteraction: false
			}}
			navigation={true}
			pagination={{clickable: true}}
			scrollbar={{draggable: true}}
			onSwiper={(swiper) => {
			}}
			onSlideChange={
				// () => console.log('slide change')
				() => {
				}
			}
		>
			{
				lives.slice(0, 3).map(live => <SwiperSlide key={live.link}><LiveBox live={live}/></SwiperSlide>)
				
			}
		</Swiper>
	);
}
